<template>
  <div class="page padding">
    <b-row>
      <b-col cols="12" xl="12">
        <b-card>
          <div slot="header">
            <b-row>
              <b-col class="d-flex align-items-center">
                <span>Usuarios</span>
              </b-col>              
              <b-col class="d-flex align-items-right">
                
              </b-col>              
              <b-col class="d-flex justify-content-end">
                <modal-permisos class="mr-3"/>
                <b-btn id="btn-new-user" size="sm" variant="success" @click="$refs.modalNuevoUsuario.toggle()" v-if="$role(['Administrador'])">
                  <i class="fa fa-user"></i>&nbsp;
                  <span>Nuevo</span>
                </b-btn>
                <b-tooltip target="btn-new-user" triggers="hover">Crear usuarios</b-tooltip>
              </b-col>
            </b-row>
          </div>
          <div class="justify-content-center d-sm-flex flex-lg-column">
            
                <b-input type="text" class="mr-3 mb-3" placeholder="Buscar por Apellido y Nombres, Codigo, E-Mail" v-model="filtro.apelnom"/>            
            
                <b-form-select class="mr-3 mb-3" :options="roles" v-model="filtro.rol">                  
                </b-form-select>

                <div class="container">
                  <div class="row">
                    <b-button class="mb-3 col-6" variant="warning" @click="getUsers()">Filtrar</b-button>
                    <b-button class="mb-3 col-6" variant="dark" @click="quitarFiltros()">Quitar Filtros</b-button>
		              </div>                  
                </div>            
          </div>
          <b-table hover striped responsive="sm" :items="users" :fields="table.fields" :current-page="table.currentPage" :per-page="table.perPage">
            <template slot="id" slot-scope="data">{{ data.item.cod_agente }}</template>
            <template slot="email" slot-scope="data">{{ data.item.email }}</template>
            <template v-slot:cell(roles)="data">
              <!--b-form-select :options="roles" v-model="data.item.rol" @change="saveUser(data.item)" :disabled="data.item.cod_agente === 9999"></b-form-select-->
             <v-select :options="rolesDisp" 
                        multiple 
                        v-model="data.item.rol"                         
                        v-on:input="saveUser(data.item)"
                        :disabled="data.item.cod_agente === 9999">
              </v-select>
            </template>
            <template #cell(opciones)="data">
              <b-btn style="margin-right:5px" v-if="data.item.cod_agente !== 9999" id="delete-user" variant="danger" @click="delUser(data.item)">
                <i class="fa fa-trash"></i>
              </b-btn>
              <b-tooltip target="delete-user">Borrar usuario</b-tooltip>

              <b-btn  v-if="data.item.cod_agente !== 9999" id="delete-user" variant="success" @click="updateUser(data.item)">
                <i class="fa fa-pencil"></i>
              </b-btn>
              <b-tooltip target="delete-user">Editar usuario</b-tooltip>
            </template>
          </b-table>
          <b-card-footer class="px-3 py-2">
            <b-row align-v="center">
              <b-col>{{ table.perPage * (table.curPage - 1) + users.length }} de {{ records }} resultados</b-col>
              <b-col>
                <b-pagination size="sm" :total-rows="records" :per-page="table.perPage" prev-text="Anterior" v-model="table.curPage" next-text="Siguiente" @change="setCurrentPage" />
              </b-col>
              <b-col></b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>

    <modal-nuevo-usuario ref="modalNuevoUsuario" :roles="rolesDisp" @change="addUser"></modal-nuevo-usuario>
    <modal-editar-usuario ref="ModalEditarUsuario" :roles="rolesDisp" :updatedUser="updatedUser" @change="updateUser"></modal-editar-usuario>
  </div>
</template>

<script>
import ModalNuevoUsuario from '@/components/Usuarios/ModalNuevoUsuario';
import ModalEditarUsuario from '@/components/Usuarios/ModalEditarUsuario';
import ModalPermisos from '@/components/Usuarios/ModalPermisos';

export default {
  name: 'UsuariosPage',
  components: {
    ModalNuevoUsuario,
    ModalEditarUsuario,
    ModalPermisos
  },
  data() {
    return {
      users: [],
      roles: [],
      rolesDisp: [],
      table: {
        fields: [
          { label: 'Código', key: 'cod_agente' },
          { label: 'Nombre', key: 'name' },
          { label: 'Email', key: 'email' },
          { label: 'Rol', key: 'roles' },
          { label: 'Opciones', key: 'opciones' },
        ],
        perPage: 10,
        curPage: 1,
      },
      records: 0,
      updatedUser: {},
      filtro: {
        rol: 0,
        apelnom: '',
        start: 0,
        length: 0
      }

    };
  },
  methods: {
    quitarFiltros(){
      this.filtro.start = (this.table.curPage - 1) * this.table.perPage, 
      this.filtro.length = this.table.perPage;
      this.filtro.apelnom = '';
      this.filtro.rol = 0;
      this.getUsers();
    },
    getUsers() {
      this.filtro.start = (this.table.curPage - 1) * this.table.perPage, 
      this.filtro.length = this.table.perPage;
      const loading = this.$loading.show();          
      return this.$api.post('roles/users', this.filtro).then((res) => {
        this.records = res.data.total_rows;
        this.users = res.data.results.map((user) => ({
          id: user.id,
          name: user.name,
          cod_agente: user.cod_agente,
          es_ejecutivo: user.cod_agente==null,
          cod_ejecutivo: user.cod_ejecutivo,
          email: user.email,
          rol: user.roles.length ? user.roles.map(x=>x.name) : null,
          factura: user.factura
        }));      
        //console.log(this.users);
        loading.hide();
      });
      /*
      return this.$api('roles/users').then(res => {
        this.users = res.data.map(user => ({
          id: user.id,
          cod_agente: user.cod_agente,
          email: user.email,
          rol: user.roles.length ? user.roles[0].name : null
        }));
      });
      */
    },
    setCurrentPage: function (n) {
      this.table.curPage = n;
      this.getUsers();
    },
    addUser(user) {
      this.getUsers();
      this.$refs.modalNuevoUsuario.toggle();
    },
    getRoles() {
      this.roles = [
        {
          value: 0,
          text: 'Seleccione Rol ...',
        },
      ];
      return this.$api.get('roles').then((res) => {
        this.rolesDisp = res.data.map(x => x.name);
        this.roles = this.roles.concat(
          res.data.map((rol) => ({
            value: rol.name,
            text: rol.name,
          }))
        );
      });
    },

    saveUser(user) {      
      this.$api.post(`roles/assign/${user.id}`, {
        name: user.rol,
      });
    },

    delUser(user) {
      this.$bvModal.msgBoxConfirm(`Está por eliminar el usuario ${user.cod_agente || user.email}. ¿Desea proceder?`)
      .then(async (value) => {
        if (value) {
          const loading = this.$loading.show();
          await this.$api.delete(`auth/usuario-interno/${user.id}`);
          this.getUsers();
          loading.hide();
        }
      });
    },

    updateUser(user) {
      this.updatedUser = user;      
      //console.log(user);
      this.$refs.ModalEditarUsuario.toggle();
    },
  },
  created: async function () {
    const loader = this.$loading.show();
    await this.getUsers();
    await this.getRoles();
    loader.hide();
  },
};
</script>

